type BrandMarkProps = {
  className?: string;
  title?: string;
};

export function BrandMark({ className = "", title }: BrandMarkProps) {
  return (
    <svg
      className={`brand-symbol ${className}`.trim()}
      viewBox="0 0 64 64"
      role={title ? "img" : undefined}
      aria-label={title}
      aria-hidden={title ? undefined : true}
      focusable="false"
    >
      <path d="M49 8H24C15.16 8 8 15.16 8 24v16c0 8.84 7.16 16 16 16h25a7 7 0 0 0 7-7v-6h-8v5H24a8 8 0 0 1-8-8V24a8 8 0 0 1 8-8h24v9h8V15a7 7 0 0 0-7-7Z" />
      <path d="M24 22h21v7H32v3h10v7H32v3h13v7H24V22Z" />
    </svg>
  );
}
